angular.module('unica_media_directory.media_directory_controllers')

.controller('MediaDirectoryListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm,
	MediaDirectoryListService, MediaDirectoryDeleteService
) {
	$scope.directoryList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.loadDirectories = function() {
		$scope.showLoader();
		$scope.canLoad = false;
		MediaDirectoryListService
			.list( $stateParams.event_id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();
				if ( data && !data.error) {
					$scope.directoryList = $scope.directoryList.concat( data );
					if ( data.length == 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.loadDirectories();

	$scope.deleteMediaDirectory = function(mediaDirectoryId) {
		$confirm({
			title: 'Sei sicuro di voler eliminare la directory?',
			text: 'Confermi la cancellazione della directory?'
		}).then(function() {

			$scope.showLoader();
			MediaDirectoryDeleteService
				.delete( mediaDirectoryId )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.directoryList, function(directory, key) {
							if ( directory.id == mediaDirectoryId ) {
								$scope.directoryList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Directory eliminata con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});
	};

	$scope.downloadExportMedia = false;
	$scope.exportMediaUrl      = '';

	$scope.prepareExportMediaUrl = function() {
		$scope.showLoader();
		MediaDirectoryListService
			.exportMedia( $stateParams.event_id, false )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportMedia = true;
					$scope.exportMediaUrl      = url;
				}
			});
	};

})

;